export const servicePlanTypes = {
  BMW_CL_SERVICE_PLAN: 'Plandeservicio',
  SUB_AU_SERVICE_PLAN: 'serviceplans',
  MINI_CL_SERVICE_PLAN: 'mini_plandeservicio',
};
